import { NominationIdRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getCountryJudgeAssignedNomination: (
  fetchContext: FetchContext,
  awardId: number,
  userId: number,
  countryId: number,
  accessToken?: string,
) => Promise<NominationIdRef> = (fetchContext, awardId, userId, countryId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/judges/${userId}/country/${countryId}/assigned-nomination`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NominationIdRef>(fetchContext.errorStore, response, 'get judge assigned nomination'));